/** Registered name of the worklet processor that turns microphone audio into Int16 PCM chunks. */
export const PCM_CHUNK_PROCESSOR_NAME = 'pcm-chunk';
